import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import {
  SubTitleTypography,
  TitleTypography,
} from "../../style/styleComponents/StyledOnboarding";
import { slides } from "../../constants/SlidesArray";

const SlideShow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { title, subtitle, SvgComponent } = slides[currentSlide];
  // Auto advance slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          minHeight: "300px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TitleTypography variant="h2">{title}</TitleTypography>

        <SubTitleTypography variant="subtitle2">{subtitle}</SubTitleTypography>

        <SvgComponent
          className="imgstyle"
          style={{ width: "100%", maxWidth: "450px", objectFit: "contain" }}
        />
      </Box>

      {/* Slide indicators */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        {slides.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentSlide(index)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor:
                currentSlide === index ? "primary.main" : "grey.300",
              mx: 1,
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SlideShow;
